module.exports = __webpack_public_path__ + "static/img/sub_event_icon2.514bc78a.svg";